module.exports = __webpack_public_path__ + "static/img/dax.16d3363.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/dax.jpg
// module id = UVbr
// module chunks = 1